export const GRAPH_URL = process.env.GRAPH_URL || "https://stg.api.top-nine.com/graph";
export const STRIPE_PK = process.env.STRIPE_PK || "pk_test_LWN6MUxa9RFHHw3pnzdKt2zd";
export const CANVAS_EDITOR_URL = process.env.CANVAS_EDITOR_URL || "https://canvas-editor-svc-stg.betalabs.studio";
export const VIDEO_TEMPLATES_URL = process.env.VIDEO_TEMPLATES_URL || "https://video-nine-server-api-stg.betalabs.studio/api/templates/topNine";

const INSTAGRAM_REDIRECT_URL = process.env.INSTAGRAM_REDIRECT_URL || "https://stg.api.top-nine.com/auth-instagram/callback/web";
const INSTAGRAM_APP_ID = process.env.INSTAGRAM_APP_ID || 635909703923362;
export const INSTAGRAM_LOGIN_URL = `https://instagram.com/oauth/authorize/?app_id=${INSTAGRAM_APP_ID}&redirect_uri=${INSTAGRAM_REDIRECT_URL}&scope=user_profile,user_media&response_type=code`;

